import React from 'react'
import { AllClaims } from '../../components/client/AllClaims'
export const Claims = () => { 
    return (
    <>
    <AllClaims/>
    
    </> )
} 